import React from 'react'
import {
  Avatar,
  Card,
  CardContent,
  Chip,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'

/** Read-only summary of a person involved, with edit / remove actions. */
const PersonInvolvedCard = ({ person, index, hidden, onEdit, onRemove }) => {
  const employee =
    person?.employee && typeof person.employee === 'object'
      ? person.employee
      : null
    console.log('employee', employee)
  const name =
    [person?.firstName, person?.lastName].filter(Boolean).join(' ') || 'Unnamed'
  const contact = [person?.email, person?.phone].filter(Boolean)

  return (
    <Card variant="outlined" sx={{ borderRadius: 2.5, height: '100%' }}>
      <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Stack direction="row" gap={1.5} alignItems="flex-start">
          <Avatar
            src={employee?.userAccount?.photograph}
            sx={{ width: 40, height: 40, bgcolor: 'action.selected' }}
          >
            {!employee && <PersonOutlineIcon fontSize="small" color="action" />}
          </Avatar>
          <Stack minWidth={0} flexGrow={1} gap={0.25}>
            <Typography
              variant="caption"
              fontWeight={700}
              color="text.secondary"
              lineHeight={1.2}
            >
              PERSON {index + 1}
            </Typography>
            <Typography fontWeight={600} noWrap>
              {name}
            </Typography>
            {contact.length > 0 ? (
              contact.map((line) => (
                <Typography
                  key={line}
                  variant="body2"
                  color="text.secondary"
                  noWrap
                >
                  {line}
                </Typography>
              ))
            ) : employee ? (
              <>
                {[
                  employee?.personnelInfo?.phoneNumber1,
                  employee?.personnelInfo?.phoneNumber2,
                  employee?.userAccount?.email,
                ].map((line, index) =>
                  line ? (
                    <Typography
                      key={index}
                      color="text.secondary"
                      noWrap
                      variant="body2"
                    >
                      {line}
                    </Typography>
                  ) : null,
                )}
              </>
            ) : (
              <Typography variant="body2" color="text.disabled">
                No contact details
              </Typography>
            )}
            <Stack
              direction="row"
              gap={0.5}
              flexWrap="wrap"
              useFlexGap
              mt={0.5}
            >
              <Chip
                size="small"
                variant="outlined"
                label={
                  employee
                    ? `Employee${employee?.clinicalRole ? ` · ${employee.clinicalRole}` : ''}`
                    : 'Other person'
                }
                sx={{ borderRadius: 1 }}
              />
              {hidden && (
                <Chip
                  size="small"
                  color="warning"
                  icon={<VisibilityOffOutlinedIcon />}
                  label="Incident hidden from them"
                  sx={{ borderRadius: 1 }}
                />
              )}
            </Stack>
          </Stack>
          <Stack direction="row" flexShrink={0}>
            {onEdit && (
              <Tooltip title="Edit">
                <IconButton
                  size="small"
                  onClick={onEdit}
                  aria-label="Edit person"
                >
                  <EditOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onRemove && (
              <Tooltip title="Remove">
                <IconButton
                  size="small"
                  color="error"
                  onClick={onRemove}
                  aria-label="Remove person"
                >
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default PersonInvolvedCard
